export default __webpack_public_path__ + "static/resistanceBands-029dcd53330917424592f9412a441075.webp";